import { createMeasurement, type MeasurementProps } from './createMeasurement';

export type MassProps = MeasurementProps<'mass'>;

/** A weight, in kilograms or pounds. */
const Mass = createMeasurement('mass', 'Mass');

export default Mass;
